// extracted by mini-css-extract-plugin
export default {"root":"styles_root__YnmUH","container":"styles_container__hesNC","wallet":"styles_wallet__M-1xV","wallet_list":"styles_wallet_list__hpZKk","link":"styles_link__cMJXg"};